import React, { useState } from 'react';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
  Button,
  Portal,
  Box,
} from '@chakra-ui/react';
import notificationIcon from '../../../Assets/notification.png';
import style from './pop.module.css';
const Popup = ({ notificationMessage, type = 'recruiter', setNewMessage }) => {
  return (
    <Popover>
      <PopoverTrigger
        onClick={() => {
          setNewMessage(0);
        }}
      >
        <img src={notificationIcon} alt='' style={{ cursor: 'pointer' }} />
      </PopoverTrigger>
      <Portal>
        <PopoverContent
          style={{
            marginTop: '30px',
          }}
        >
          <PopoverArrow />
          <PopoverHeader borderBottom={'1px solid #E7E6E8'}>
            <p className={style.notiText}> Notifications </p>
          </PopoverHeader>
          <PopoverCloseButton />
          {notificationMessage?.length > 0 &&
            notificationMessage.map((item) => (
              <Box
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-between'}
                borderBottom={'1px solid #E7E6E8;'}
              >
                <Box display={'flex'} flexDirection={'column'} padding={'15px'}>
                  <Box
                    fontSize={'18px'}
                    fontWeight={'500'}
                    fontFamily={'Roboto'}
                  >
                    {item?.message}
                  </Box>
                </Box>
              </Box>
            ))}
          {notificationMessage?.length === 0 && (
            <Box display={'flex'} flexDirection={'column'} padding={'15px'}>
              <Box fontSize={'18px'} fontWeight={'500'} fontFamily={'Roboto'}>
                No Notifications
              </Box>
            </Box>
          )}
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default Popup;
